import { create } from "zustand";

interface HotspotState {
  /** Hotspot cuya ficha está abierta en el SidePanel; null = cerrada. */
  selectedId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useHotspotStore = create<HotspotState>()((set) => ({
  selectedId: null,
  open: (selectedId) => set({ selectedId }),
  close: () => set({ selectedId: null }),
}));
